import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import {
  CategoryFacet,
  RegularFacet,
  RegularFacetState,
  Unsubscribe,
} from '@coveo/headless/commerce';
import {
  FacetViewEvent,
  FacetViewOperation,
  ToggleFacetEvent,
} from '@app/new-search/models/new-search-facets.model';

@Component({
  selector: 'app-regular-facet',
  templateUrl: './regular-facet.component.html',
  styleUrls: ['./regular-facet.component.scss'],
})
export class RegularFacetComponent implements OnInit, OnDestroy {
  @Input() controller: RegularFacet;
  @Output() regularFacetsSelected = new EventEmitter<ToggleFacetEvent>();
  @Output() regularFacetLoadValues = new EventEmitter<FacetViewEvent>();
  @Output() setCurrentFacetIdEmitter = new EventEmitter<string>();
  facetViewEnum = FacetViewOperation;
  stateUnsubscribe: Unsubscribe;
  state: RegularFacetState;
  showSearchFacet = false;

  ngOnInit() {
    this.stateUnsubscribe = this.controller.subscribe(() => {
      this.state = this.controller.state;
    });
  }

  ngOnDestroy(): void {
    if (this.stateUnsubscribe) {
      this.stateUnsubscribe();
    }
  }

  trackFacetValueId(index: number, facetValue: any) {
    return facetValue.value;
  }

  handleCheckboxSelection(facet, value) {
    this.regularFacetsSelected.emit({ facet: facet, value: value });
  }

  showMoreFacetValues(facet: RegularFacet | CategoryFacet) {
    this.regularFacetLoadValues.emit({
      facet,
      operation: this.facetViewEnum.viewMore,
    });
  }

  showLessFacetValues(facet: RegularFacet | CategoryFacet) {
    this.regularFacetLoadValues.emit({
      facet,
      operation: this.facetViewEnum.viewLess,
    });
  }

  setShowSearchFacet(event) {
    this.showSearchFacet = event;
  }

  setCurrentFacetId(facetId) {
    this.setCurrentFacetIdEmitter.emit(facetId);
  }
}
